module.exports = "/_next/static/images/express-17d761c751cc6eaa70b5aa536777f5fd.png";